if (!customElements.get('collection-description-toggle')) {
  class CollectionDescriptionToggle extends HTMLElement {
    connectedCallback() {
      this._inner = this.querySelector('.collection-desc__inner');
      this._btn = this.querySelector('.collection-desc__toggle');
      if (!this._inner || !this._btn) return;

      this._truncate = this.hasAttribute('data-truncate');
      this._onResize = () => this._applyTruncate();

      if (!this._truncate) {
        this._btn.hidden = true;
        return;
      }

      this._btn.addEventListener('click', () => this._toggle());
      window.addEventListener('resize', this._onResize);
      requestAnimationFrame(() => this._applyTruncate());
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    _maxHeightPx() {
      const raw = getComputedStyle(this).getPropertyValue('--collection-desc-max-height').trim();
      const n = parseFloat(raw);
      return Number.isFinite(n) && n > 0 ? n : 200;
    }

    _fullScrollHeight() {
      const prev = this._inner.style.maxHeight;
      this._inner.style.maxHeight = 'none';
      const h = this._inner.scrollHeight;
      this._inner.style.maxHeight = prev;
      return h;
    }

    _applyTruncate() {
      if (!this._truncate || !this._inner || !this._btn) return;

      const maxH = this._maxHeightPx();
      const full = this._fullScrollHeight();

      if (full <= maxH + 2) {
        this._btn.hidden = true;
        this.classList.remove('collection-desc--collapsible', 'collection-desc--expanded');
        this._inner.removeAttribute('style');
        return;
      }

      this.classList.add('collection-desc--collapsible');
      this._btn.hidden = false;

      if (this.classList.contains('collection-desc--expanded')) {
        this._inner.style.maxHeight = 'none';
        this._syncButtonLabel(true);
      } else {
        this._inner.style.maxHeight = `${maxH}px`;
        this._syncButtonLabel(false);
      }
    }

    _syncButtonLabel(expanded) {
      const more = this._btn.dataset.textMore || this._btn.textContent;
      const less = this._btn.dataset.textLess || more;
      this._btn.textContent = expanded ? less : more;
      this._btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    _toggle() {
      const maxH = this._maxHeightPx();
      const expanded = this.classList.toggle('collection-desc--expanded');

      if (expanded) {
        this._inner.style.maxHeight = 'none';
      } else {
        this._inner.style.maxHeight = `${maxH}px`;
      }
      this._syncButtonLabel(expanded);
    }
  }

  customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}